import dpdLogo from '../../assets/dpd-logo.png';

function YourItems() {
  return (
    <div className="center-items">
      <p
        style={{
          paddingBottom: '3%',
          fontSize: '23px',
          textAlign: 'center',
        }}
      >
        Your medication collection from ePharmNI
      </p>
      <img style={{ width: '19%', minWidth: '95px' }} src={dpdLogo} alt="DPD logo" />
    </div>
  );
}

export default YourItems;
